<template>
  <div class="h5-container">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="brand">
        <span class="logo-text">洋么科技</span>
        <span class="badge">培养高级AI测开工程师</span>
      </div>
      <!-- 添加返回首页按钮到导航栏右侧 -->
      <button class="home-btn" @click="goToHome">
        返回首页
      </button>
    </nav>
    <!-- 主要内容区域 -->
    <div class="result-section">
      <!-- 图标区域 -->
      <div class="result-icon" :class="iconClass">
        <span class="icon-text">{{ iconText }}</span>
      </div>
      <!-- 标题 -->
      <h1 class="result-title">{{ title }}</h1>
      <!-- 描述信息 -->
      <div class="result-description">
        <p>{{ subTitle }}</p>
      </div>
      <!-- 操作按钮 -->
      <div class="result-actions" v-if="showPayButton">
        <button class="action-btn" @click="handleButtonClick">
          确认支付结果
        </button>
      </div>
      <!-- 底部提示 - 根据支付状态动态显示 -->
      <div class="result-footer">
        <!-- 支付成功时显示的提示 -->
        <div v-if="icon === 'success'">
          <div class="footer-item">
            <div class="footer-icon">⏰</div>
            <div class="footer-text">联系时间：早10点 ~ 晚10点间</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">📞</div>
            <div class="footer-text">来电号码：归属地为深圳的私人手机号</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">💡</div>
            <div class="footer-text">试听失效：24小时未联系上将自动退款</div>
          </div>
        </div>
        <!-- 支付失败时显示的提示 -->
        <div v-else-if="icon === 'error'">
          <div class="footer-item">
            <div class="footer-icon">⚠️</div>
            <div class="footer-text">支付未成功，您的信息不会被保存</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">🔄</div>
            <div class="footer-text">如需试听，请返回首页重新支付</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">⏳</div>
            <div class="footer-text">未支付成功，我们不会联系您安排试听</div>
          </div>
        </div>
        <!-- 待确认状态时显示的提示 -->
        <div v-else>
          <div class="footer-item">
            <div class="footer-icon">🔍</div>
            <div class="footer-text">系统正在自动确认您的支付状态</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">⏱️</div>
            <div class="footer-text">如果已支付，请耐心等待确认结果</div>
          </div>
          <div class="footer-item">
            <div class="footer-icon">💡</div>
            <div class="footer-text">确认失败可点击按钮手动查询</div>
          </div>
        </div>
      </div>
      <!-- 添加底部返回首页按钮（大按钮） -->
      <div class="home-actions">
        <button class="home-action-btn" @click="goToHome">
          ← 返回首页继续了解课程
        </button>
      </div>
    </div>
    <!-- 底部备案信息 -->
    <div class="footer-notice">
      <!-- 添加备案信息中的返回首页链接 -->
      <div class="footer-links">
        <a href="javascript:void(0)" @click="goToHome" class="footer-link">返回首页</a>
        <span class="footer-separator">|</span>
        <a href="http://beian.miit.gov.cn" target="_blank" class="footer-link">湘ICP备2024068691号</a>
      </div>
      <div class="footer-copyright">
        <img src="/static/logo.ico" alt="公司Logo" class="footer-logo">
        <span>©2026 张家界市洋么科技有限公司</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      icon: 'info',
      title: '请确认支付结果',
      subTitle: '请点击下方按钮确认您的支付状态。支付成功我们会立即安排试听，支付失败则不会联系您。',
      outTradeNo: '',
      payType: '',
      showPayButton: true,
      maxPollCount: 10,
      pollInterval: null,
      pollCount: 0
    }
  },
  computed: {
    iconClass () {
      return {
        'icon-info': this.icon === 'info',
        'icon-success': this.icon === 'success',
        'icon-error': this.icon === 'error'
      }
    },
    iconText () {
      switch (this.icon) {
        case 'success': return '✓'
        case 'error': return '✕'
        default: return 'i'
      }
    }
  },
  mounted () {
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    // 返回首页方法
    goToHome () {
      this.$router.push('/')
    },
    async handleButtonClick () {
      this.outTradeNo = localStorage.getItem('outTradeNo')
      this.payType = localStorage.getItem('payType')
      const bilibili = localStorage.getItem('bilibili')
      try {
        const response = await fetch(`/api/pay/payment/getPaymentStatus/?out_trade_no=${this.outTradeNo}&payType=${this.payType}`)
        if (!response.ok) {
          throw new Error('请求失败')
        }
        const result = await response.json()
        if (result.code === 0) {
          if (bilibili === '1') {
            // window.bilicm?.mbase?.report_data?.()
          }
          this.icon = 'success'
          this.title = '支付成功！试听安排中'
          this.subTitle = '恭喜您已成功购买全栈AI测开教程试听！我们的教程作者将在24小时内（早10点~晚10点）亲自联系您，安排专属试听服务。请保持电话畅通，期待与您沟通！'
          this.showPayButton = false
          this.stopPolling()
        } else if (result.code === 1) {
          this.icon = 'error'
          this.title = '支付未完成'
          this.subTitle = '检测到您尚未完成支付。若放弃支付，您的信息将不会被保存，我们也不会联系您。'
          this.showPayButton = false
        }
      } catch (error) {
        console.error('支付状态查询失败:', error)
        this.icon = 'error'
        this.title = '查询异常'
        this.subTitle = '支付状态查询遇到问题，请稍后重试或联系客服。'
        this.showPayButton = true
      }
    },
    startPolling () {
      this.pollInterval = setInterval(() => {
        this.pollCount++
        if (this.pollCount <= this.maxPollCount) {
          this.handleButtonClick()
        } else {
          this.stopPolling()
          this.icon = 'info'
          this.title = '请手动确认支付结果'
          this.subTitle = '系统已自动查询多次。如果您已完成支付但仍未收到成功提示，请点击下方按钮手动确认。'
          this.showPayButton = true
        }
      }, 3000)
    },
    stopPolling () {
      if (this.pollInterval) {
        clearInterval(this.pollInterval)
        this.pollInterval = null
      }
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: 'DengXian';
  src: local('DengXian'), local('Microsoft YaHei Light')
}
.h5-container {
  background-color: #f2f4f7;
  color: #333;
  font-family: 'DengXian', sans-serif;
  font-weight: 300;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
/* 导航栏 */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}
.brand {
  display: flex;
  align-items: center;
}
.logo-text {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
}
.badge {
  font-size: 10px;
  background: #333;
  color: #fff;
  padding: 2px 8px;
  border-radius: 20px;
  margin-left: 5px;
}
/* 导航栏返回首页按钮 */
.home-btn {
  background: transparent;
  border: 1px solid #333;
  padding: 8px 15px;
  font-size: 12px;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.home-btn:hover {
  background: #f5f5f5;
}
/* 结果区域 */
.result-section {
  flex: 1;
  background: #fff;
  margin: 20px;
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.02);
}
/* 图标 */
.result-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  font-weight: bold;
}
.icon-info {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}
.icon-success {
  background: linear-gradient(135deg, #07C160 0%, #5cdd8b 100%);
  color: #fff;
}
.icon-error {
  background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
  color: #fff;
}
/* 标题 */
.result-title {
  font-size: 24px;
  color: #000;
  margin-bottom: 20px;
  font-weight: 600;
}
/* 描述 */
.result-description {
  background: #f8f9fb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  text-align: left;
}
.result-description p {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  margin: 0;
}
/* 操作按钮 */
.result-actions {
  margin-bottom: 40px;
}
.action-btn {
  background: linear-gradient(135deg, #2c68ff 0%, #6a11cb 100%);
  color: #fff;
  border: none;
  padding: 16px 40px;
  border-radius: 15px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(44, 104, 255, 0.25);
}
.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(44, 104, 255, 0.3);
}
.action-btn:active {
  transform: translateY(0);
}
/* 底部提示 */
.result-footer {
  border-top: 1px dashed #eee;
  padding-top: 25px;
  margin-bottom: 30px;
}
/* 底部提示样式 - 优化图标颜色 */
.footer-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 13px;
  color: #666;
  text-align: left;
}
.footer-icon {
  width: 24px;
  height: 24px;
  background: #f2f4f7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  font-size: 12px;
}
/* 支付成功状态 - 绿色主题 */
.footer-item .footer-icon[style*="⏰"],
.footer-item .footer-icon[style*="📞"],
.footer-item .footer-icon[style*="💡"] {
  background: rgba(7, 193, 96, 0.1);
  color: #07C160;
}
/* 支付失败状态 - 红色主题 */
.footer-item .footer-icon[style*="⚠️"] {
  background: rgba(255, 107, 107, 0.1);
  color: #ff6b6b;
}
.footer-item .footer-icon[style*="🔄"] {
  background: rgba(255, 171, 0, 0.1);
  color: #ffab00;
}
.footer-item .footer-icon[style*="⏳"] {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}
/* 待确认状态 - 蓝色主题 */
.footer-item .footer-icon[style*="🔍"] {
  background: rgba(44, 104, 255, 0.1);
  color: #2c68ff;
}
.footer-item .footer-icon[style*="⏱️"] {
  background: rgba(106, 17, 203, 0.1);
  color: #6a11cb;
}
.footer-text {
  flex: 1;
}
/* 底部返回首页按钮（大按钮） */
.home-actions {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px dashed #eee;
}
.home-action-btn {
  width: 100%;
  background: transparent;
  border: 1px solid #2c68ff;
  color: #2c68ff;
  padding: 16px;
  border-radius: 15px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.home-action-btn:hover {
  background: rgba(44, 104, 255, 0.05);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(44, 104, 255, 0.1);
}
/* 底部备案信息 */
.footer-notice {
  font-size: 10px;
  text-align: center;
  padding: 20px 15px;
  line-height: 1.4;
  color: #666;
  background: #fff;
  margin-top: auto;
  border-top: 1px solid #f0f0f0;
}
.footer-links {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
.footer-link {
  color: #2c68ff;
  text-decoration: none;
  font-size: 12px;
  padding: 0 8px;
  transition: color 0.3s ease;
}
.footer-link:hover {
  text-decoration: underline;
}
.footer-separator {
  color: #ccc;
  font-size: 12px;
}
.footer-copyright {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 8px;
}
.footer-logo {
  height: 1.2em;
  vertical-align: middle;
}
/* 响应式调整 */
@media (max-width: 375px) {
  .result-section {
    margin: 10px;
    padding: 30px 15px;
  }
  .result-title {
    font-size: 20px;
  }
  .action-btn, .home-action-btn {
    width: 100%;
  }
  .footer-links {
    flex-direction: column;
    gap: 5px;
  }
  .footer-separator {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/payresult.vue